// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ServiceCategories_SalvarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/service_categories/salvar
 *
 * Creates or updates a service category.
 * - Create: requires name only (categories are now global, no franchise_id)
 * - Update: requires id + name
 */
import { registerContract } from './validate'

export interface ServiceCategories_SalvarInput {
so_service_category_name: string
so_service_category_id?: number
so_service_category_icon_svg?: string
}

registerContract('ServiceCategories_SalvarInput', {
  so_service_category_name:     { type: 'string',  required: true },
  so_service_category_id:       { type: 'number',  required: false },
  so_service_category_icon_svg: { type: 'string',  required: false },
})
